import {
  BackgroundColor,
  BlockContentValue,
  PartialSanityImageType,
  SanityImage,
  SanityImageRatio,
  SectionContainer
} from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import { BlockContent } from "components/BlockContent";
import { useBottomSticky } from "components/StickyMenu/useSticky";
import React, { ReactElement, useRef } from "react";
import * as styles from "./BrochureStickyBar.module.scss";

type Props = {
  image?: PartialSanityImageType;
  content?: string | BlockContentValue;
  backgroundColor?: BackgroundColor | "titaniumDark";

  ctaButton: ReactElement;
  dataContentName?: string;
};

const BrochureStickyBar: React.FC<React.PropsWithChildren<Props>> = ({
  image,
  content,
  ctaButton,
  dataContentName,
  children,
  backgroundColor
}) => {
  const stickyRef = useRef<HTMLDivElement>(null);
  const isSticky = useBottomSticky(stickyRef);

  return (
    <React.Fragment>
      <div
        ref={stickyRef}
        className={clsx(styles.nav, {
          [styles.isSticky]: isSticky,
          [styles.backgroundWhite]: backgroundColor == "white",
          [styles.backgroundNeutral05]: backgroundColor == "neutral05",
          [styles.backgroundNeutral10]: backgroundColor == "neutral10",
          [styles.backgroundTitaniumDark]: backgroundColor == "titaniumDark"
        })}
        data-content-name={dataContentName}
      >
        <SectionContainer
          className={styles.section}
          backgroundColor="transparent"
          spacingBottom={null}
          spacingTop={null}
        >
          <div className={styles.imgContainer}>
            <div className={styles.imgContainerWrapper}>
              {image && (
                <SanityImageRatio image={image} ratio="auto">
                  <SanityImage image={image} />
                </SanityImageRatio>
              )}
            </div>
          </div>

          <div className={styles.content}>
            <BlockContent value={content} />
          </div>
          <div className={styles.cta}>{ctaButton}</div>
        </SectionContainer>
      </div>
      <div className={styles.innerComponent}>{children}</div>
    </React.Fragment>
  );
};

export default BrochureStickyBar;
